export const PHONE = "+34691622449";
export const PHONE_DISPLAY = "+34 691 622 449";
export const WA_LINK = "https://wa.me/34691622449";
export const SITE_URL = "https://ecoglowdetailing.es";

export function waQuote(message) {
  return `${WA_LINK}?text=${encodeURIComponent(message)}`;
}

export const IMG = {
  hero: "https://images.unsplash.com/photo-1567808291548-fc3ee04dbcf0?crop=entropy&cs=srgb&fm=jpg&q=85",
  heroDark: "https://images.unsplash.com/photo-1645400379459-f6fd3d963fd4?crop=entropy&cs=srgb&fm=jpg&q=85",
  side: "https://images.unsplash.com/photo-1485291571150-772bcfc10da5?crop=entropy&cs=srgb&fm=jpg&q=85",
  interior: "https://images.unsplash.com/photo-1732357624591-f2137085659b?crop=entropy&cs=srgb&fm=jpg&q=85",
  leather: "https://images.unsplash.com/photo-1605437241278-c1806d14a4d9?crop=entropy&cs=srgb&fm=jpg&q=85",
  interiorWork: "https://images.unsplash.com/photo-1608259243654-70c070e0f6ed?crop=entropy&cs=srgb&fm=jpg&q=85",
  polishing: "https://images.unsplash.com/photo-1708805282676-0c15476eb8a2?crop=entropy&cs=srgb&fm=jpg&q=85",
  correction: "https://images.unsplash.com/photo-1708805282706-f44730b7e527?crop=entropy&cs=srgb&fm=jpg&q=85",
  ceramic: "https://images.unsplash.com/photo-1658244500543-47f32dc51dc2?crop=entropy&cs=srgb&fm=jpg&q=85",
};

export const ZONES = [
  "Els Muntells",
  "Amposta",
  "Deltebre",
  "Sant Jaume d'Enveja",
  "La Ràpita",
  "Tortosa",
];

export const ZONES_EXTRA = ["Camarles", "L'Aldea", "La Cava", "Jesús i Maria", "Bítem"];

export const SERVICES = [
  {
    slug: "limpieza-interior",
    img: IMG.interior,
    icon: "Armchair",
    home: true,
    es: {
      name: "Limpieza interior",
      short: "Limpieza interior profunda de tapicería, plásticos, moquetas y zonas difíciles.",
      h1: "Limpieza interior profunda de coches",
      excerpt: "Devolvemos el interior de tu coche a un estado impecable: aspirado profundo, tapicería, plásticos y cada rincón.",
      includes: [
        "Aspirado profundo de habitáculo y maletero",
        "Limpieza de asientos y tapicería",
        "Limpieza de moquetas y alfombrillas",
        "Limpieza y acondicionado de plásticos",
        "Detallado de rejillas, juntas y zonas difíciles",
        "Cristales interiores y acabado final",
      ],
      body: [
        "La limpieza interior profunda es mucho más que pasar el aspirador. Trabajamos cada superficie con el producto y la técnica adecuados: techo, asientos, tapicería, moquetas, salpicadero, plásticos, gomas y esas zonas que nunca se limpian: carriles de los asientos, rejillas de ventilación, guanteras y huecos.",
        "Utilizamos química específica para cada material y herramientas de detallado que respetan las superficies. El objetivo es que cuando abras la puerta, el coche huela y se sienta como nuevo.",
        "Este servicio está disponible en nuestro centro de Els Muntells y también a domicilio en toda la zona de servicio: Amposta, Deltebre, Sant Jaume d'Enveja, La Ràpita, Tortosa y localidades cercanas.",
      ],
      where: "En nuestro centro de Els Muntells y a domicilio (es nuestro servicio móvil por excelencia).",
      keywords: "limpieza interior de coches, limpieza profunda de vehículos, detailing interior, limpieza de tapicería de coche",
      seoTitle: "Limpieza interior profunda de coches en Els Muntells | EcoGlow Detailing",
      seoDesc: "Limpieza interior profunda de coches: aspirado, tapicería, plásticos y moquetas. En nuestro centro de Els Muntells o a domicilio en Amposta, Deltebre, Tortosa y zona.",
    },
    ca: {
      name: "Neteja interior",
      short: "Neteja interior profunda de tapisseria, plàstics, moquetes i zones difícils.",
      h1: "Neteja interior profunda de cotxes",
      excerpt: "Tornem l'interior del teu cotxe a un estat impecable: aspirat profund, tapisseria, plàstics i cada racó.",
      includes: [
        "Aspirat profund d'habitacle i maleter",
        "Neteja de seients i tapisseria",
        "Neteja de moquetes i catifes",
        "Neteja i acondicionat de plàstics",
        "Detallat de reixetes, juntes i zones difícils",
        "Vidres interiors i acabat final",
      ],
      body: [
        "La neteja interior profunda és molt més que passar l'aspirador. Treballem cada superfície amb el producte i la tècnica adequats: sostre, seients, tapisseria, moquetes, tauler, plàstics, gomes i aquelles zones que mai no es netegen: carrils dels seients, reixetes de ventilació, guanteres i forats.",
        "Utilitzem química específica per a cada material i eines de detallat que respecten les superfícies. L'objectiu és que quan obres la porta, el cotxe faci olor i se senti com nou.",
        "Aquest servei està disponible al nostre centre dels Muntells i també a domicili a tota la zona de servei: Amposta, Deltebre, Sant Jaume d'Enveja, la Ràpita, Tortosa i localitats properes.",
      ],
      where: "Al nostre centre dels Muntells i a domicili (és el nostre servei mòbil per excel·lència).",
      keywords: "neteja interior de cotxes, neteja profunda de vehicles, detailing interior, neteja de tapisseria de cotxe",
      seoTitle: "Neteja interior profunda de cotxes als Muntells | EcoGlow Detailing",
      seoDesc: "Neteja interior profunda de cotxes: aspirat, tapisseria, plàstics i moquetes. Al nostre centre dels Muntells o a domicili a Amposta, Deltebre, Tortosa i zona.",
    },
  },
  {
    slug: "limpieza-exterior",
    img: IMG.heroDark,
    icon: "Droplets",
    home: true,
    es: {
      name: "Limpieza exterior",
      short: "Lavado profesional a mano con prelavado, llantas, neumáticos y acabado cuidado.",
      h1: "Limpieza exterior profesional de coches",
      excerpt: "Un lavado a mano de verdad: prelavado, dos cubos, llantas, neumáticos y secado sin marcas.",
      includes: [
        "Prelavado con espuma activa",
        "Lavado exterior a mano (método dos cubos)",
        "Limpieza específica de llantas",
        "Limpieza e hidratación de neumáticos",
        "Secado con toalla microfibra y aire",
        "Cristales exteriores y acabado",
      ],
      body: [
        "El lavado profesional empieza donde acaba el túnel de lavado: en la mano, el producto adecuado y el respeto por la pintura. Aplicamos prelavado con espuma activa para reblandecer la suciedad sin frotar, y lavamos a mano con el método de dos cubos para no arrastrar partículas por la carrocería.",
        "Las llantas y los neumáticos reciben su propio tratamiento: desengrasante específico, cepillos dedicados e hidratación de gomas para un acabado oscuro y cuidado.",
        "Terminamos con secado sin marcas y cristales exteriores. Este servicio se realiza en nuestro centro de Els Muntells.",
      ],
      where: "En nuestro centro de Els Muntells (con opción de recogida y entrega del vehículo).",
      keywords: "limpieza exterior de coches, lavado profesional, limpieza de carrocería, detailing exterior",
      seoTitle: "Limpieza exterior profesional de coches | EcoGlow Detailing Els Muntells",
      seoDesc: "Lavado profesional a mano: prelavado, llantas, neumáticos y secado sin marcas. Centro de detailing en Els Muntells, Tarragona. Recogida y entrega disponible.",
    },
    ca: {
      name: "Neteja exterior",
      short: "Rentat professional a mà amb pre-rentat, llantes, pneumàtics i acabat cuidat.",
      h1: "Neteja exterior professional de cotxes",
      excerpt: "Un rentat a mà de debò: pre-rentat, dos galledes, llantes, pneumàtics i assecat sense marques.",
      includes: [
        "Pre-rentat amb escuma activa",
        "Rentat exterior a mà (mètode dues galledes)",
        "Neteja específica de llantes",
        "Neteja i hidratació de pneumàtics",
        "Assecat amb tovallola microfibra i aire",
        "Vidres exteriors i acabat",
      ],
      body: [
        "El rentat professional comença on acaba el túnel de rentat: a la mà, el producte adequat i el respecte per la pintura. Apliquem pre-rentat amb escuma activa per afluixar la brutícia sense fregar, i rentem a mà amb el mètode de dues galledes per no arrossegar partícules per la carrosseria.",
        "Les llantes i els pneumàtics reben el seu propi tractament: desgreixant específic, raspalls dedicats i hidratació de gomes per a un acabat fosc i cuidat.",
        "Acabem amb assecat sense marques i vidres exteriors. Aquest servei es realitza al nostre centre dels Muntells.",
      ],
      where: "Al nostre centre dels Muntells (amb opció de recollida i lliurament del vehicle).",
      keywords: "neteja exterior de cotxes, rentat professional, neteja de carrosseria, detailing exterior",
      seoTitle: "Neteja exterior professional de cotxes | EcoGlow Detailing Els Muntells",
      seoDesc: "Rentat professional a mà: pre-rentat, llantes, pneumàtics i assecat sense marques. Centre de detailing als Muntells, Tarragona. Recollida i lliurament disponible.",
    },
  },
  {
    slug: "detailing-integral",
    img: IMG.side,
    icon: "Sparkles",
    home: true,
    es: {
      name: "Detailing integral",
      short: "Cuidado completo del automóvil: interior, exterior, pintura y protección.",
      h1: "Detailing profesional para vehículos",
      excerpt: "El cuidado completo: interior, exterior, pintura y protección en un único tratamiento coordinado.",
      includes: [
        "Diagnóstico completo del vehículo",
        "Limpieza interior profunda",
        "Limpieza exterior completa",
        "Descontaminación de pintura",
        "Corrección de pintura según estado",
        "Protección adaptada (Fusso Coat o cerámica)",
      ],
      body: [
        "El detailing integral es la suma de todo lo que sabemos hacer, aplicado a tu coche de forma coordinada. Empezamos con un diagnóstico: estado de la pintura, del interior, de las llantas, de los cristales y de los plásticos. A partir de ahí definimos el plan de trabajo contigo.",
        "Un tratamiento integral suele combinar limpieza interior profunda, limpieza exterior completa, descontaminación de la pintura, corrección (pulido One-Step o dos pasos según el estado) y una protección final: Fusso Coat o tratamiento cerámico.",
        "Si tu coche necesita volver a sentirse nuevo por dentro y por fuera, esta es la opción. Te asesoramos sin compromiso sobre qué combinación tiene sentido para tu vehículo y tu presupuesto.",
      ],
      where: "En nuestro centro de Els Muntells, con recogida y entrega del vehículo disponible.",
      keywords: "detailing profesional, detailing de coches, detailing integral, cuidado completo del automóvil",
      seoTitle: "Detailing integral profesional para vehículos | EcoGlow Els Muntells",
      seoDesc: "Detailing integral: limpieza interior y exterior, corrección de pintura y protección cerámica o Fusso Coat. Centro profesional en Els Muntells, Tarragona.",
    },
    ca: {
      name: "Detailing integral",
      short: "Cura completa de l'automòbil: interior, exterior, pintura i protecció.",
      h1: "Detailing professional per a vehicles",
      excerpt: "La cura completa: interior, exterior, pintura i protecció en un únic tractament coordinat.",
      includes: [
        "Diagnòstic complet del vehicle",
        "Neteja interior profunda",
        "Neteja exterior completa",
        "Descontaminació de pintura",
        "Correcció de pintura segons estat",
        "Protecció adaptada (Fusso Coat o ceràmica)",
      ],
      body: [
        "El detailing integral és la suma de tot el que sabem fer, aplicat al teu cotxe de forma coordinada. Comencem amb un diagnòstic: estat de la pintura, de l'interior, de les llantes, dels vidres i dels plàstics. A partir d'aquí definim el pla de treball amb tu.",
        "Un tractament integral sol combinar neteja interior profunda, neteja exterior completa, descontaminació de la pintura, correcció (polit One-Step o dues passes segons l'estat) i una protecció final: Fusso Coat o tractament ceràmic.",
        "Si el teu cotxe necessita tornar a sentir-se nou per dins i per fora, aquesta és l'opció. T'assessorem sense compromís sobre quina combinació té sentit per al teu vehicle i el teu pressupost.",
      ],
      where: "Al nostre centre dels Muntells, amb recollida i lliurament del vehicle disponible.",
      keywords: "detailing professional, detailing de cotxes, detailing integral, cura completa de l'automòbil",
      seoTitle: "Detailing integral professional per a vehicles | EcoGlow Els Muntells",
      seoDesc: "Detailing integral: neteja interior i exterior, correcció de pintura i protecció ceràmica o Fusso Coat. Centre professional als Muntells, Tarragona.",
    },
  },
  {
    slug: "limpieza-interior-a-domicilio",
    img: IMG.interiorWork,
    icon: "Home",
    es: {
      name: "Limpieza interior a domicilio",
      short: "La limpieza interior profunda donde esté tu coche: casa, trabajo o garaje.",
      h1: "Limpieza interior de coches a domicilio",
      excerpt: "Llevamos la limpieza interior profesional a tu domicilio en Els Muntells, Amposta, Deltebre y toda la zona.",
      includes: [
        "Aspirado profundo in situ",
        "Limpieza de asientos y tapicería",
        "Plásticos, salpicadero y consola",
        "Moquetas y alfombrillas",
        "Cristales interiores",
        "Acabado y revisión contigo",
      ],
      body: [
        "Nuestro servicio móvil es exclusivamente para limpiezas interiores. Vamos a tu domicilio, tu trabajo o tu garaje con todo el equipo necesario y realizamos la limpieza interior profunda allí mismo: no necesitas mover el coche ni adaptarte a horarios de taller.",
        "Trabajamos en Els Muntells, Amposta, Deltebre, Sant Jaume d'Enveja, La Ràpita, Tortosa y localidades cercanas. Solo necesitamos un espacio razonable para trabajar alrededor del vehículo y, si es posible, un punto de luz cercano.",
        "Para reservar, escríbenos por WhatsApp indicando tu localidad, el modelo del coche y el estado general del interior. Te confirmamos fecha, duración aproximada y precio según el tamaño del vehículo (S, M o XL).",
        "Los tratamientos de pintura (pulido, corrección, Fusso Coat, cerámica) se realizan siempre en nuestro centro, porque requieren condiciones controladas. Para esos servicios ofrecemos recogida y entrega del vehículo.",
      ],
      where: "A domicilio en toda la zona de servicio. Exclusivamente limpiezas interiores.",
      keywords: "limpieza de coches a domicilio, limpieza interior a domicilio, detailing a domicilio, limpieza de coche en casa",
      seoTitle: "Limpieza interior de coches a domicilio | EcoGlow Detailing",
      seoDesc: "Limpieza interior de coches a domicilio en Els Muntells, Amposta, Deltebre, Sant Jaume d'Enveja, La Ràpita y Tortosa. Reserva por WhatsApp.",
    },
    ca: {
      name: "Neteja interior a domicili",
      short: "La neteja interior profunda on sigui el teu cotxe: casa, feina o garatge.",
      h1: "Neteja interior de cotxes a domicili",
      excerpt: "Portem la neteja interior professional al teu domicili als Muntells, Amposta, Deltebre i tota la zona.",
      includes: [
        "Aspirat profund in situ",
        "Neteja de seients i tapisseria",
        "Plàstics, tauler i consola",
        "Moquetes i catifes",
        "Vidres interiors",
        "Acabat i revisió amb tu",
      ],
      body: [
        "El nostre servei mòbil és exclusivament per a neteges interiors. Anem al teu domicili, la teva feina o el teu garatge amb tot l'equip necessari i fem la neteja interior profunda allà mateix: no cal que moguis el cotxe ni que t'adaptis a horaris de taller.",
        "Treballem als Muntells, Amposta, Deltebre, Sant Jaume d'Enveja, la Ràpita, Tortosa i localitats properes. Només necessitem un espai raonable per treballar al voltant del vehicle i, si és possible, un punt de llum proper.",
        "Per reservar, escriu-nos per WhatsApp indicant la teva localitat, el model del cotxe i l'estat general de l'interior. Et confirmem data, durada aproximada i preu segons la mida del vehicle (S, M o XL).",
        "Els tractaments de pintura (polit, correcció, Fusso Coat, ceràmica) es fan sempre al nostre centre, perquè requereixen condicions controlades. Per a aquests serveis oferim recollida i lliurament del vehicle.",
      ],
      where: "A domicili a tota la zona de servei. Exclusivament neteges interiors.",
      keywords: "neteja de cotxes a domicili, neteja interior a domicili, detailing a domicili, neteja de cotxe a casa",
      seoTitle: "Neteja interior de cotxes a domicili | EcoGlow Detailing",
      seoDesc: "Neteja interior de cotxes a domicili als Muntells, Amposta, Deltebre, Sant Jaume d'Enveja, la Ràpita i Tortosa. Reserva per WhatsApp.",
    },
  },
  {
    slug: "pulido-de-coches",
    img: IMG.polishing,
    icon: "Disc3",
    home: true,
    es: {
      name: "Pulido de coches",
      short: "Pulido One-Step y de dos pasos para recuperar brillo y corregir defectos.",
      h1: "Pulido profesional de coches",
      excerpt: "Recuperamos el brillo de tu pintura con pulido One-Step o corrección en dos pasos, según su estado.",
      includes: [
        "Evaluación de la pintura con luz de inspección",
        "Lavado y descontaminación previa",
        "Pulido One-Step o dos pasos según necesidad",
        "Corrección de defectos compatibles con el proceso",
        "Medición de espesores en zonas sensibles",
        "Acabado y consejos de mantenimiento",
      ],
      body: [
        "Con el tiempo, la pintura acumula microarañazos, hologramas, marcas de lavado y oxidación que apagan el color. El pulido elimina una finísima capa de barniz dañado para devolver profundidad y brillo a la pintura.",
        "El pulido One-Step combina corte y acabado en un solo paso: ideal para pinturas con defectos leves o moderados y para mejorar mucho el brillo con una sola intervención. El pulido de dos pasos separa un paso de corte (corrección real de defectos) y un paso de refinado (acabado espejo), para pinturas más castigadas.",
        "Antes de pulir evaluamos la pintura con luz de inspección y te decimos con franqueza qué defectos se pueden corregir y cuáles no: rayadas profundas que atraviesan el barniz no se eliminan puliendo. Después te damos pautas de mantenimiento para que el resultado dure.",
      ],
      where: "En nuestro centro de Els Muntells (requiere condiciones controladas). Recogida y entrega disponible.",
      keywords: "pulido de coches, pulido One-Step, pulido de dos pasos, brillo de pintura, pulir coche",
      seoTitle: "Pulido profesional de coches en Els Muntells | EcoGlow Detailing",
      seoDesc: "Pulido One-Step y pulido de dos pasos para recuperar el brillo y corregir defectos de pintura. Centro de detailing en Els Muntells, Tarragona.",
    },
    ca: {
      name: "Polit de cotxes",
      short: "Polit One-Step i de dues passes per recuperar brillantor i corregir defectes.",
      h1: "Polit professional de cotxes",
      excerpt: "Recuperem la brillantor de la teva pintura amb polit One-Step o correcció en dues passes, segons l'estat.",
      includes: [
        "Avaluació de la pintura amb llum d'inspecció",
        "Rentat i descontaminació prèvia",
        "Polit One-Step o dues passes segons necessitat",
        "Correcció de defectes compatibles amb el procés",
        "Mesurament de gruixos en zones sensibles",
        "Acabat i consells de manteniment",
      ],
      body: [
        "Amb el temps, la pintura acumula microratllades, hologrames, marques de rentat i oxidació que apaguen el color. El polit elimina una finíssima capa de vernís danyat per tornar profunditat i brillantor a la pintura.",
        "El polit One-Step combina tall i acabat en una sola passa: ideal per a pintures amb defectes lleus o moderats i per millorar molt la brillantor amb una sola intervenció. El polit de dues passes separa una passa de tall (correcció real de defectes) i una passa de refinat (acabat mirall), per a pintures més malmeses.",
        "Abans de polir avaluem la pintura amb llum d'inspecció i et diem amb franquesa quins defectes es poden corregir i quins no: ratllades profundes que travessen el vernís no s'eliminen polint. Després et donem pautes de manteniment perquè el resultat durés.",
      ],
      where: "Al nostre centre dels Muntells (requereix condicions controlades). Recollida i lliurament disponible.",
      keywords: "polit de cotxes, polit One-Step, polit de dues passes, brillantor de pintura, polir cotxe",
      seoTitle: "Polit professional de cotxes als Muntells | EcoGlow Detailing",
      seoDesc: "Polit One-Step i polit de dues passes per recuperar la brillantor i corregir defectes de pintura. Centre de detailing als Muntells, Tarragona.",
    },
  },
  {
    slug: "correccion-de-pintura",
    img: IMG.correction,
    icon: "ScanSearch",
    es: {
      name: "Corrección de pintura",
      short: "Corrección real de arañazos, hologramas y marcas de lavado en la pintura.",
      h1: "Corrección de pintura profesional",
      excerpt: "Eliminamos hologramas, marcas de lavado y microarañazos para devolver la pintura a su mejor versión.",
      includes: [
        "Inspección con luz específica",
        "Descontaminación química y mecánica",
        "Corrección en uno o dos pasos según el defecto",
        "Refinado hasta acabado espejo",
        "Protección posterior recomendada",
        "Informe honesto de lo corregible",
      ],
      body: [
        "La corrección de pintura es el proceso de eliminar defectos del barniz: microarañazos circulares (swirls), hologramas de pulidos anteriores, marcas de lavado automático, manchas de agua grabadas y oxidación superficial.",
        "No todo es corregible: las rayadas que atraviesan el barniz hasta la capa de color no desaparecen puliendo, y siempre te lo diremos antes de empezar. Trabajamos con luz de inspección y te enseñamos el estado real de tu pintura.",
        "La corrección se realiza con pulido de uno o dos pasos según la dureza del barniz y la profundidad de los defectos. Después recomendamos proteger el resultado con Fusso Coat o tratamiento cerámico: no tiene sentido corregir para volver a dañar.",
      ],
      where: "En nuestro centro de Els Muntells. Recogida y entrega disponible.",
      keywords: "corrección de pintura, eliminar arañazos coche, swirls, hologramas pintura, pulir pintura",
      seoTitle: "Corrección de pintura profesional en Els Muntells | EcoGlow Detailing",
      seoDesc: "Corrección de pintura: eliminamos swirls, hologramas y marcas de lavado. Diagnóstico honesto y acabado espejo en Els Muntells, Tarragona.",
    },
    ca: {
      name: "Correcció de pintura",
      short: "Correcció real de ratllades, hologrames i marques de rentat a la pintura.",
      h1: "Correcció de pintura professional",
      excerpt: "Eliminem hologrames, marques de rentat i microratllades per tornar la pintura a la seva millor versió.",
      includes: [
        "Inspecció amb llum específica",
        "Descontaminació química i mecànica",
        "Correcció en una o dues passes segons el defecte",
        "Refinat fins a acabat mirall",
        "Protecció posterior recomanada",
        "Informe honest del corregible",
      ],
      body: [
        "La correcció de pintura és el procés d'eliminar defectes del vernís: microratllades circulars (swirls), hologrames de polits anteriors, marques de rentat automàtic, taques d'aigua gravades i oxidació superficial.",
        "No tot és corregible: les ratllades que travessen el vernís fins a la capa de color no desapareixen polint, i sempre t'ho direm abans de començar. Treballem amb llum d'inspecció i t'ensenyem l'estat real de la teva pintura.",
        "La correcció es fa amb polit d'una o dues passes segons la duresa del vernís i la profunditat dels defectes. Després recomanem protegir el resultat amb Fusso Coat o tractament ceràmic: no té sentit corregir per tornar a danyar.",
      ],
      where: "Al nostre centre dels Muntells. Recollida i lliurament disponible.",
      keywords: "correcció de pintura, eliminar ratllades cotxe, swirls, hologrames pintura, polir pintura",
      seoTitle: "Correcció de pintura professional als Muntells | EcoGlow Detailing",
      seoDesc: "Correcció de pintura: eliminem swirls, hologrames i marques de rentat. Diagnòstic honest i acabat mirall als Muntells, Tarragona.",
    },
  },
  {
    slug: "proteccion-fusso-coat",
    img: IMG.correction,
    icon: "ShieldCheck",
    home: true,
    es: {
      name: "Protección Fusso Coat",
      short: "Protección hidrofóbica con duración anunciada de hasta 12 meses.",
      h1: "Protección hidrofóbica Fusso Coat para coches",
      excerpt: "Fusso Coat de Soft99: repelencia al agua espectacular y hasta 12 meses de protección según el uso.",
      includes: [
        "Lavado y descontaminación previa",
        "Preparación de la superficie",
        "Aplicación de Fusso Coat (Soft99)",
        "Repelencia al agua y a la suciedad",
        "Brillo intenso y tacto sedoso",
        "Pautas de mantenimiento",
      ],
      body: [
        "Fusso Coat es el sellado hidrofóbico de referencia de Soft99, la marca japonesa especializada en cuidado del automóvil. Crea una capa sobre el barniz que repele el agua de forma espectacular: las gotas resbalan y se llevan parte de la suciedad con ellas.",
        "La preparación es clave: antes de aplicar el producto lavamos y descontaminamos la pintura para que el sellado se ancle correctamente. Si la pintura tiene defectos, recomendamos pulir antes (un One-Step suele ser suficiente), porque un sellado no corrige, solo protege lo que hay debajo.",
        "El fabricante anuncia una duración de hasta 12 meses, que dependerá de las condiciones de uso: kilómetros, lavados, exposición al sol y al salitre del Delta. Te explicamos cómo lavar el coche para alargar la vida del tratamiento.",
      ],
      where: "En nuestro centro de Els Muntells. Recogida y entrega disponible.",
      keywords: "Fusso Coat, protección hidrofóbica, sellado de pintura, tratamiento hidrofóbico, Soft99",
      seoTitle: "Protección hidrofóbica Fusso Coat en Els Muntells | EcoGlow Detailing",
      seoDesc: "Fusso Coat de Soft99: protección hidrofóbica hasta 12 meses según uso. Aplicación profesional con preparación de pintura en Els Muntells, Tarragona.",
    },
    ca: {
      name: "Protecció Fusso Coat",
      short: "Protecció hidrofòbica amb durada anunciada de fins a 12 mesos.",
      h1: "Protecció hidrofòbica Fusso Coat per a cotxes",
      excerpt: "Fusso Coat de Soft99: repel·lència a l'aigua espectacular i fins a 12 mesos de protecció segons l'ús.",
      includes: [
        "Rentat i descontaminació prèvia",
        "Preparació de la superfície",
        "Aplicació de Fusso Coat (Soft99)",
        "Repel·lència a l'aigua i a la brutícia",
        "Brillantor intensa i tacte sedós",
        "Pautes de manteniment",
      ],
      body: [
        "Fusso Coat és el segellat hidrofòbic de referència de Soft99, la marca japonesa especialitzada en cura de l'automòbil. Crea una capa sobre el vernís que repel·leix l'aigua de forma espectacular: les gotes llisquen i s'emporten part de la brutícia amb elles.",
        "La preparació és clau: abans d'aplicar el producte rentem i descontaminem la pintura perquè el segellat s'ancori correctament. Si la pintura té defectes, recomanem polir abans (un One-Step sol ser suficient), perquè un segellat no corregeix, només protegeix el que hi ha a sota.",
        "El fabricant anuncia una durada de fins a 12 mesos, que dependrà de les condicions d'ús: quilòmetres, rentats, exposició al sol i al salnitre del Delta. T'expliquem com rentar el cotxe per allargar la vida del tractament.",
      ],
      where: "Al nostre centre dels Muntells. Recollida i lliurament disponible.",
      keywords: "Fusso Coat, protecció hidrofòbica, segellat de pintura, tractament hidrofòbic, Soft99",
      seoTitle: "Protecció hidrofòbica Fusso Coat als Muntells | EcoGlow Detailing",
      seoDesc: "Fusso Coat de Soft99: protecció hidrofòbica fins a 12 mesos segons ús. Aplicació professional amb preparació de pintura als Muntells, Tarragona.",
    },
  },
  {
    slug: "tratamiento-ceramico",
    img: IMG.ceramic,
    icon: "Gem",
    home: true,
    es: {
      name: "Tratamiento cerámico",
      short: "Protección cerámica profesional con preparación y corrección previa.",
      h1: "Tratamiento cerámico profesional para coches",
      excerpt: "La protección más duradera: preparación exhaustiva, corrección previa y aplicación cerámica profesional.",
      includes: [
        "Preparación completa de la pintura",
        "Descontaminación química y mecánica",
        "Corrección previa cuando corresponda",
        "Aplicación del recubrimiento cerámico",
        "Tiempo de curado controlado",
        "Guía de mantenimiento cerámico",
      ],
      body: [
        "El tratamiento cerámico es la protección más avanzada para la pintura: un recubrimiento que se adhiere químicamente al barniz creando una capa dura, hidrofóbica y resistente a químicos, rayos UV y suciedad.",
        "El 80% del resultado es la preparación. Descontaminamos la pintura, la corregimos cuando corresponde (pulido One-Step o dos pasos) y la desengrasamos antes de aplicar el cerámico. Después respetamos el tiempo de curado en condiciones controladas del centro.",
        "Somos transparentes con los beneficios y las limitaciones: el cerámico facilita el lavado, da brillo profundo y protege durante años con buen mantenimiento, pero no hace el coche invulnerable a rayadas ni a impactos de gravilla. No prometemos duraciones de catálogo: te explicamos qué esperar según tu uso real.",
      ],
      where: "En nuestro centro de Els Muntells (curado controlado). Recogida y entrega disponible.",
      keywords: "tratamiento cerámico, protección cerámica coche, coating cerámico, cerámica pintura",
      seoTitle: "Tratamiento cerámico profesional en Els Muntells | EcoGlow Detailing",
      seoDesc: "Tratamiento cerámico profesional: preparación, corrección previa y aplicación con curado controlado. Centro de detailing en Els Muntells, Tarragona.",
    },
    ca: {
      name: "Tractament ceràmic",
      short: "Protecció ceràmica professional amb preparació i correcció prèvia.",
      h1: "Tractament ceràmic professional per a cotxes",
      excerpt: "La protecció més duradora: preparació exhaustiva, correcció prèvia i aplicació ceràmica professional.",
      includes: [
        "Preparació completa de la pintura",
        "Descontaminació química i mecànica",
        "Correcció prèvia quan correspongui",
        "Aplicació del recobriment ceràmic",
        "Temps de curat controlat",
        "Guia de manteniment ceràmic",
      ],
      body: [
        "El tractament ceràmic és la protecció més avançada per a la pintura: un recobriment que s'adhereix químicament al vernís creant una capa dura, hidrofòbica i resistent a químics, rajos UV i brutícia.",
        "El 80% del resultat és la preparació. Descontaminem la pintura, la corregim quan correspon (polit One-Step o dues passes) i la desgreixem abans d'aplicar el ceràmic. Després respectem el temps de curat en condicions controlades del centre.",
        "Som transparents amb els beneficis i les limitacions: el ceràmic facilita el rentat, dona brillantor profunda i protegeix durant anys amb bon manteniment, però no fa el cotxe invulnerable a ratllades ni a impactes de grava. No prometem durades de catàleg: t'expliquem què esperar segons el teu ús real.",
      ],
      where: "Al nostre centre dels Muntells (curat controlat). Recollida i lliurament disponible.",
      keywords: "tractament ceràmic, protecció ceràmica cotxe, coating ceràmic, ceràmica pintura",
      seoTitle: "Tractament ceràmic professional als Muntells | EcoGlow Detailing",
      seoDesc: "Tractament ceràmic professional: preparació, correcció prèvia i aplicació amb curat controlat. Centre de detailing als Muntells, Tarragona.",
    },
  },
  {
    slug: "restauracion-de-faros",
    img: IMG.hero,
    icon: "Lightbulb",
    home: true,
    es: {
      name: "Restauración de faros",
      short: "Recuperamos faros amarillentos y opacos: mejor visión y mejor aspecto.",
      h1: "Restauración profesional de faros de coche",
      excerpt: "Faros amarillentos y opacos recuperados: mejora estética, mejor visión nocturna y mejor resultado en ITV.",
      includes: [
        "Evaluación del estado del policarbonato",
        "Lijado progresivo controlado",
        "Pulido hasta transparencia",
        "Sellado protector UV",
        "Mejora visual inmediata",
        "Consejos de mantenimiento",
      ],
      body: [
        "Con los años, el sol degrada el policarbonato de los faros: se vuelven amarillentos, opacos y rugosos. Además de feo, es un problema de seguridad: un faro degradado ilumina mucho menos de noche.",
        "La restauración consiste en retirar la capa degradada con lijado progresivo, pulir hasta recuperar la transparencia y sellar el faro con protección UV para frenar que vuelva a degradarse. La mejora visual es inmediata y espectacular.",
        "Es uno de los servicios con mejor relación precio-resultado: 25 € el par, y el coche parece años más joven. Se realiza en nuestro centro de Els Muntells o como extra dentro de otros tratamientos.",
      ],
      where: "En nuestro centro de Els Muntells, o como extra de otros servicios.",
      keywords: "restauración de faros, faros amarillentos, pulir faros, faros opacos, pulido de faros",
      seoTitle: "Restauración de faros de coche en Els Muntells | EcoGlow Detailing",
      seoDesc: "Restauramos faros amarillentos y opacos: lijado, pulido y sellado UV. 25 € el par. Centro de detailing en Els Muntells, Tarragona.",
    },
    ca: {
      name: "Restauració de fars",
      short: "Recuperem fars groguencs i opacs: millor visió i millor aspecte.",
      h1: "Restauració professional de fars de cotxe",
      excerpt: "Fars groguencs i opacs recuperats: millora estètica, millor visió nocturna i millor resultat a la ITV.",
      includes: [
        "Avaluació de l'estat del policarbonat",
        "Llatjat progressiu controlat",
        "Polit fins a transparència",
        "Segellat protector UV",
        "Millora visual immediata",
        "Consells de manteniment",
      ],
      body: [
        "Amb els anys, el sol degrada el policarbonat dels fars: es tornen groguencs, opacs i rugosos. A més de lletjós, és un problema de seguretat: un far degradat il·lumina molt menys de nit.",
        "La restauració consisteix a retirar la capa degradada amb llatjat progressiu, polir fins a recuperar la transparència i segellar el far amb protecció UV per frenar que es torni a degradar. La millora visual és immediata i espectacular.",
        "És un dels serveis amb millor relació preu-resultat: 25 € el parell, i el cotxe sembla anys més jove. Es realitza al nostre centre dels Muntells o com a extra dins d'altres tractaments.",
      ],
      where: "Al nostre centre dels Muntells, o com a extra d'altres serveis.",
      keywords: "restauració de fars, fars groguencs, polir fars, fars opacs, polit de fars",
      seoTitle: "Restauració de fars de cotxe als Muntells | EcoGlow Detailing",
      seoDesc: "Restaurem fars groguencs i opacs: llatjat, polit i segellat UV. 25 € el parell. Centre de detailing als Muntells, Tarragona.",
    },
  },
  {
    slug: "servicios-extra",
    img: IMG.polishing,
    icon: "Wrench",
    es: {
      name: "Servicios extra",
      short: "Limpieza de motor, antilluvia, hidratación de cuero e hidratación de faros.",
      h1: "Servicios extra de detailing",
      excerpt: "Los detalles que completan el trabajo: motor, antilluvia, cuero e hidratación de faros.",
      extras: [
        {
          name: "Limpieza de motor",
          price: "30 €",
          img: IMG.polishing,
          desc: "Limpieza y acondicionado del vano motor con productos específicos, respetando conexiones y electrónica. Un motor limpio transmite cuidado y ayuda a detectar fugas.",
        },
        {
          name: "Tratamiento antilluvia",
          price: "20 €",
          img: IMG.heroDark,
          desc: "Tratamiento hidrofóbico para lunas delanteras y retrovisores con duración de hasta 12 meses: la lluvia resbala y mejora la visibilidad sin apenas usar limpiaparabrisas.",
        },
        {
          name: "Hidratación de cuero",
          price: "30 €",
          img: IMG.leather,
          desc: "Limpieza e hidratación profunda de asientos y superficies de cuero para recuperar flexibilidad, color y tacto, y prevenir grietas.",
        },
        {
          name: "Restauración de faros",
          price: "25 € el par",
          img: IMG.hero,
          desc: "Recuperación de faros amarillentos y opacos mediante lijado, pulido y sellado UV. Mejor estética y mejor visión nocturna.",
        },
        {
          name: "Hidratación de faros",
          price: "Consultar",
          img: IMG.side,
          desc: "Mantenimiento protector de faros ya restaurados o en buen estado para frenar la degradación por el sol.",
        },
      ],
      body: [
        "Los extras son esos servicios que completan un detailing de verdad. Puedes añadirlos a cualquier limpieza, pulido o pack, o contratarlos por separado.",
        "Cada extra tiene su precio cerrado (salvo la hidratación de faros, que presupuestamos según el estado) y se realiza en nuestro centro de Els Muntells o dentro de un servicio mayor.",
      ],
      where: "En nuestro centro de Els Muntells, solos o como complemento de otros servicios.",
      keywords: "limpieza de motor, tratamiento antilluvia, hidratación de cuero, restauración de faros, extras detailing",
      seoTitle: "Servicios extra de detailing: motor, antilluvia, cuero | EcoGlow Els Muntells",
      seoDesc: "Limpieza de motor 30 €, tratamiento antilluvia 20 €, hidratación de cuero 30 € y restauración de faros 25 € el par. EcoGlow Detailing, Els Muntells.",
    },
    ca: {
      name: "Serveis extra",
      short: "Neteja de motor, antipluja, hidratació de cuir i hidratació de fars.",
      h1: "Serveis extra de detailing",
      excerpt: "Els detalls que completen la feina: motor, antipluja, cuir i hidratació de fars.",
      extras: [
        {
          name: "Neteja de motor",
          price: "30 €",
          img: IMG.polishing,
          desc: "Neteja i acondicionat de la caixa del motor amb productes específics, respectant connexions i electrònica. Un motor net transmet cura i ajuda a detectar fuites.",
        },
        {
          name: "Tractament antipluja",
          price: "20 €",
          img: IMG.heroDark,
          desc: "Tractament hidrofòbic per a llunes davanteres i retrovisors amb durada de fins a 12 mesos: la pluja llisca i millora la visibilitat sense gairebé fer servir l'escombra.",
        },
        {
          name: "Hidratació de cuir",
          price: "30 €",
          img: IMG.leather,
          desc: "Neteja i hidratació profunda de seients i superfícies de cuir per recuperar flexibilitat, color i tacte, i prevenir esquerdes.",
        },
        {
          name: "Restauració de fars",
          price: "25 € el parell",
          img: IMG.hero,
          desc: "Recuperació de fars groguencs i opacs mitjançant llatjat, polit i segellat UV. Millor estètica i millor visió nocturna.",
        },
        {
          name: "Hidratació de fars",
          price: "Consultar",
          img: IMG.side,
          desc: "Manteniment protector de fars ja restaurats o en bon estat per frenar la degradació pel sol.",
        },
      ],
      body: [
        "Els extres són aquells serveis que completen un detailing de debò. Els pots afegir a qualsevol neteja, polit o pack, o contractar-los per separat.",
        "Cada extra té el seu preu tancat (llevat de la hidratació de fars, que pressupostem segons l'estat) i es realitza al nostre centre dels Muntells o dins d'un servei major.",
      ],
      where: "Al nostre centre dels Muntells, sols o com a complement d'altres serveis.",
      keywords: "neteja de motor, tractament antipluja, hidratació de cuir, restauració de fars, extres detailing",
      seoTitle: "Serveis extra de detailing: motor, antipluja, cuir | EcoGlow Els Muntells",
      seoDesc: "Neteja de motor 30 €, tractament antipluja 20 €, hidratació de cuir 30 € i restauració de fars 25 € el parell. EcoGlow Detailing, Els Muntells.",
    },
  },
];

export const HOME_SERVICES = SERVICES.filter((s) => s.home);

export const HOME_EXTRAS = [
  {
    key: "limpieza-motor",
    price: "30 €",
    img: IMG.polishing,
    es: { name: "Limpieza de motor", short: "Limpieza y acondicionado del vano motor con productos específicos." },
    ca: { name: "Neteja de motor", short: "Neteja i acondicionat de la caixa del motor amb productes específics." },
  },
  {
    key: "tratamiento-antilluvia",
    price: "20 €",
    img: IMG.heroDark,
    es: { name: "Tratamiento antilluvia", short: "Hidrofóbico para lunas y retrovisores con duración de hasta 12 meses." },
    ca: { name: "Tractament antipluja", short: "Hidrofòbic per a llunes i retrovisors amb durada de fins a 12 mesos." },
  },
  {
    key: "hidratacion-cuero",
    price: "30 €",
    img: IMG.leather,
    es: { name: "Hidratación de cuero", short: "Limpieza e hidratación profunda del cuero para recuperar flexibilidad y color." },
    ca: { name: "Hidratació de cuir", short: "Neteja i hidratació profunda del cuir per recuperar flexibilitat i color." },
  },
];

export function getService(slug) {
  return SERVICES.find((s) => s.slug === slug);
}

export const PRICING = {
  cleaning: [
    { key: "limpieza-interior", es: "Limpieza interior profunda", ca: "Neteja interior profunda", prices: [99, 119, 159] },
    { key: "limpieza-exterior", es: "Limpieza exterior completa", ca: "Neteja exterior completa", prices: [29, 39, 54] },
  ],
  correction: [
    { key: "pulido-de-coches", es: "Pulido One-Step", ca: "Polit One-Step", prices: [158, 189, 230] },
    { key: "pulido-de-coches", es: "Pulido de dos pasos", ca: "Polit de dues passes", prices: [249, 289, 359] },
  ],
  protection: [
    { key: "proteccion-fusso-coat", es: "Fusso Coat", ca: "Fusso Coat", prices: ["+59", "+69", "+79"] },
    { key: "tratamiento-ceramico", es: "Tratamiento cerámico", ca: "Tractament ceràmic", prices: ["+149", "+179", "+229"] },
  ],
  packs: [
    { id: "esencial", prices: [109, 139, 194], recommended: false },
    { id: "escudo", prices: [269, 339, 454], recommended: true },
    { id: "maxima", prices: [429, 529, 704], recommended: false },
  ],
  extras: [
    { es: "Limpieza de motor", ca: "Neteja de motor", price: "30 €" },
    { es: "Tratamiento antilluvia 12 meses", ca: "Tractament antipluja 12 mesos", price: "20 €" },
    { es: "Hidratación de cuero", ca: "Hidratació de cuir", price: "30 €" },
    { es: "Restauración de faros", ca: "Restauració de fars", price: "25 € / par", priceCa: "25 € / parell" },
  ],
};
